/**
 * External provider configuration.
 *
 * These constants are separated from Oauth2RedirectScreen.tsx
 * to enable Fast Refresh. Non-component exports in the same file as components
 * break HMR.
 */

export enum ExternalProvider {
  AGRIWEBB = "AGRIWEBB",
}

export const externalProviderRetryUrl = {
  [ExternalProvider.AGRIWEBB]:
    "https://portal.agriwebb.com/accounts/marketplace",
};

export const externalProviderName = {
  [ExternalProvider.AGRIWEBB]: "AgriWebb",
};
